import { EditIcon } from "@/constant/imagePath";
import React from "react";

function BaseEdit({ editTableData }) {
  return (
    <button
      onClick={() => editTableData?.onClick()}
      className="h-8 min-w-[120px] bg-edit-table-gradient flex items-center justify-center gap-x-2 font-extralight text-sm text-white hover:underline underline-offset-1 rounded-7 shadow-primary-inset"
    >
      <img src={EditIcon} className="h-4" alt="Edit Table" />
      <span>Edit Table</span>
    </button>
  );
}

export default BaseEdit;
